import { render, staticRenderFns } from "./reservedItemsList.vue?vue&type=template&id=008f5ade&scoped=true&"
import script from "./reservedItemsList.vue?vue&type=script&lang=js&"
export * from "./reservedItemsList.vue?vue&type=script&lang=js&"
import style0 from "./reservedItemsList.vue?vue&type=style&index=0&id=008f5ade&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008f5ade",
  null
  
)

export default component.exports